import React, { useState } from 'react';
import { Page, Card, FormLayout, TextField, Button, Banner, BlockStack } from '@shopify/polaris';

const AdminLogin: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://nilhosqgvmsabnljpavo.supabase.co';
      const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || '';

      const response = await fetch(`${supabaseUrl}/functions/v1/admin-login`, {
        method: 'POST',
        headers: {
          'apikey': supabaseAnonKey,
          'Authorization': `Bearer ${supabaseAnonKey}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();
      if (response.ok && data.token) {
        localStorage.setItem('admin_token', data.token);
        // Forçar navegação com reload completo
        setTimeout(() => {
          window.location.href = '/admin/dashboard';
        }, 100);
      } else {
        setError(data.error || 'Incorrect email or password');
      }
    } catch (err) {
      setError('Error logging in. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Page narrowWidth>
      <Card>
        <BlockStack gap="500">
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <h1 style={{ fontSize: '28px', fontWeight: '700', marginBottom: '8px' }}>
              Admin Panel
            </h1>
            <p style={{ color: '#6c757d' }}>Acesso restrito</p>
          </div>

          {error && (
            <Banner tone="critical" onDismiss={() => setError(null)}>
              {error}
            </Banner>
          )}

          <form onSubmit={handleSubmit}>
            <FormLayout>
              <TextField
                label="Email"
                type="email"
                value={email}
                onChange={setEmail}
                autoComplete="email"
              />
              <TextField
                label="Senha"
                type="password"
                value={password}
                onChange={setPassword}
                autoComplete="current-password"
              />
              <Button submit loading={loading} variant="primary" fullWidth>
                Entrar
              </Button>
            </FormLayout>
          </form>
        </BlockStack>
      </Card>
    </Page>
  );
};

export default AdminLogin;

